/**
 * Update color variant name display when user selects a different color
 */
(function () {
  "use strict";

  function updateColorVariantName() {
    // Find all color swatches
    jQuery(".swatch.variant_div").each(function () {
      var $swatch = jQuery(this);
      var $header = $swatch.find(".header");
      var $variantValueSpan = $header.find(".variant-value");
      var $colorPreviewBox = $header.find(".color-preview-box");

      // Only proceed if this swatch has the variant-value span (meaning it's a color option)
      if ($variantValueSpan.length === 0) return;

      // Function to update color preview box
      function updateColorPreview(colorName) {
        if ($colorPreviewBox.length && colorName) {
          // Convert color name to actual color
          // This handles standard CSS color names like "white", "black", "orange", etc.
          var colorValue = colorName.toLowerCase().trim();

          // Create a temporary element to get computed color
          var tempEl = jQuery("<div>")
            .css("color", colorValue)
            .appendTo("body");
          var computedColor = tempEl.css("color");
          tempEl.remove();

          // Apply the color
          $colorPreviewBox.css({
            "background-color": computedColor,
            "background-image": "none",
          });
        }
      }

      // Initialize with current selected variant
      var $checkedInput = $swatch.find(
        '.swatch-element input[type="radio"]:checked'
      );
      if ($checkedInput.length) {
        var initialColor = $checkedInput.val();
        updateColorPreview(initialColor);
      }

      // Listen for changes on swatch radio inputs
      $swatch
        .find('.swatch-element input[type="radio"]')
        .on("change", function () {
          if (this.checked) {
            var selectedValue = jQuery(this).val();
            $variantValueSpan.text(selectedValue);
            updateColorPreview(selectedValue);
          }
        });

      // Also update on label click (in case the event doesn't bubble properly)
      $swatch.find(".swatch-element label").on("click", function () {
        var $input = jQuery(this).prev('input[type="radio"]');
        if ($input.length) {
          var selectedValue = $input.val();
          $variantValueSpan.text(selectedValue);
          updateColorPreview(selectedValue);
        }
      });
    });
  }

  // Initialize on document ready
  jQuery(document).ready(function () {
    updateColorVariantName();
  });

  // Re-initialize after Shopify's OptionSelectors runs
  jQuery(window).on("load", function () {
    setTimeout(updateColorVariantName, 100);
  });

  // Add color box to tooltips for color swatches
  function enhanceColorTooltips() {
    // Find all color swatch labels with tippy tooltips
    jQuery(".swatch-element.color label[data-tippy-content]").each(function () {
      var $label = jQuery(this);
      var colorName = $label.attr("data-tippy-content");

      if (colorName && colorName.indexOf("<span") === -1) {
        // Only process if not already HTML
        // Convert color name to CSS color
        var colorValue = colorName.toLowerCase().trim();
        var tempEl = jQuery("<div>").css("color", colorValue).appendTo("body");
        var computedColor = tempEl.css("color");
        tempEl.remove();

        // Create HTML content with color box
        var tooltipHTML =
          '<span class="tooltip-color-box" style="display:inline-block;width:16px;height:16px;border:1px solid #ddd;margin-right:6px;vertical-align:middle;background-color:' +
          computedColor +
          ';"></span><span style="vertical-align:middle;">' +
          colorName +
          "</span>";

        // Store original color name and set HTML
        $label.data("original-color-name", colorName);
        $label.attr("data-tippy-content", tooltipHTML);
        $label.attr("data-tippy-allowHTML", "true");

        // Destroy existing tippy instance if exists
        if ($label[0]._tippy) {
          $label[0]._tippy.destroy();
        }
      }
    });

    // Reinitialize tippy for color swatches with HTML support
    if (typeof tippy !== "undefined") {
      tippy(".swatch-element.color label[data-tippy-allowHTML='true']", {
        allowHTML: true,
        theme: "sharpborder",
        arrow: true,
        inertia: true,
        animation: "shift-away",
        delay: 50,
      });
    }
  }

  // Run tooltip enhancement after page loads
  jQuery(window).on("load", function () {
    setTimeout(enhanceColorTooltips, 500);
  });
})();
